/**
 * Group dashboard widget types in the sidebar.
 */
Vue.asyncComponent('cms-dashboard-widget-type-group', {
    /**
     * Create the reactive state for this dashboard component.
     */
    data() {
        return {
            isOpen: false,
        };
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        blockTypes: {
            type: Array,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
        },
        searchActive: {
            type: Boolean,
        },
        collapsedStates: {
            type: Object,
        },
    },
    methods: {
        /**
         * Forward child drag start events to the parent list.
         */
        childDragStart(type) {
            this.$emit('childDragStart', type);
        },
        /**
         * Forward child drag end events to the parent list.
         */
        childDragStop() {
            this.$emit('childDragStop');
        },
        /**
         * Toggle the open state and persist it in local storage.
         */
        toggleIsOpen() {
            this.isOpen = !this.isOpen;

            const states = localStorage.getItem('cms-dashboard-widget-group-collapsed-state')
                ? JSON.parse(localStorage.getItem('cms-dashboard-widget-group-collapsed-state'))
                : {};

            states[this.id] = this.isOpen;

            localStorage.setItem('cms-dashboard-widget-group-collapsed-state', JSON.stringify(states));
        },
    },
    /**
     * Initialize this dashboard component after it is created.
     */
    created() {
        // Restore the persisted collapsed state when available.
        this.isOpen = this.defaultOpen;

        if (this.collapsedStates && this.collapsedStates[this.id] !== undefined) {
            this.isOpen = this.collapsedStates[this.id];
        }
    },
}, 'cms/dashboard/editor/cms-dashboard-widget-type-group.html');
